import React from "react";
import PropTypes from "prop-types";
import { CreateContainer } from "./ContainerCreate";
import { getPlaylist } from "~/api/getCustomPlaylists";

class CustomPlaylistContainer extends React.Component {
  componentDidMount() {
    const { playlistId } = this.props;
    // console.log("🚀 ~ file: CustomPlaylistContainer.js:9 ~ CustomPlaylistContainer ~ componentDidMount ~ playlistId:", playlistId);
    this.props.request(playlistId);
  }
  componentWillReceiveProps(nextProps) {
    const { playlistId: nextPlaylistId } = nextProps;
    const { playlistId } = this.props;
    if (nextPlaylistId !== playlistId) {
      this.props.request(nextPlaylistId);
    }
  }

  render = () => {
    window.scrollTo(0, 0);
    const { data, loading, failure, render } = this.props;

    const playlist = (data && data.data) || {};

    return render({ playlist, loading, failure });
  };
}

CustomPlaylistContainer.propTypes = {
  playlistId: PropTypes.number.isRequired,
};

export default CreateContainer(getPlaylist, CustomPlaylistContainer);
